// src/lib/crypto/errors.ts

export class ZKPAError extends Error {
  constructor(message: string, public readonly code: string) {
    super(message);
    this.name = "ZKPAError";
  }
}

export class ZKPABrowserUnsupportedError extends ZKPAError {
  constructor() {
    super(
      "Web Crypto API not available. Please use Chrome 37+, Firefox 34+, Safari 11+, or Edge 12+.",
      "BROWSER_UNSUPPORTED"
    );
    this.name = "ZKPABrowserUnsupportedError";
  }
}

export class ZKPAKeyNotInitializedError extends ZKPAError {
  constructor() {
    super(
      "Master Key not loaded. User must authenticate first.",
      "KEY_NOT_INITIALIZED"
    );
    this.name = "ZKPAKeyNotInitializedError";
  }
}

export class ZKPADecryptionError extends ZKPAError {
  constructor(context: string) {
    super(`Decryption failed: ${context}`, "DECRYPTION_FAILED");
    this.name = "ZKPADecryptionError";
  }
}

export class ZKPASignatureError extends ZKPAError {
  constructor() {
    super("Ed25519 signature verification failed.", "SIGNATURE_INVALID");
    this.name = "ZKPASignatureError";
  }
}
